import React from "react";
import { TableCell, TableSortLabel, type SxProps, type Theme } from "@mui/material";

interface SortableTableCellProps<T extends string> {
  label: string;
  field: T;
  sortBy: T;
  sortOrder: "asc" | "desc";
  onSort: (field: T) => void;
  align?: "left" | "right" | "center";
  width?: number | string;
  sx?: SxProps<Theme>;
}

function SortableTableCell<T extends string>({
  label,
  field,
  sortBy,
  sortOrder,
  onSort,
  align,
  width,
  sx,
}: SortableTableCellProps<T>) {
  return (
    <TableCell
      align={align}
      width={width}
      sx={sx}
      sortDirection={sortBy === field ? sortOrder : false}
    >
      <TableSortLabel
        active={sortBy === field}
        direction={sortBy === field ? sortOrder : "asc"}
        onClick={() => onSort(field)}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );
}

export default SortableTableCell;
